import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MacedFrontendAngularComponentModule } from '@maced/angular-components';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TextEditorComponent } from './text-editor/text-editor.component'
import { CardComponent } from './card/card.component';
import { ButtonComponent } from './button/button.component';
import { FooterComponent } from './footer/footer.component';
import { DropdownWithoutLabelComponent } from './dropdown-without-label/dropdown-without-label.component';
import { HeaderComponent } from './header/header.component';
import { SteponeComponent } from './stepper/steps/stepone/stepone.component';
import { SteptwoComponent } from './stepper/steps/steptwo/steptwo.component';
import { StepfinalComponent } from './stepper/steps/stepfinal/stepfinal.component';
import { StepperwithrouteComponent } from './stepper/stepperwithroute/stepperwithroute.component';
import { StepperComponent } from './stepper/stepper.component';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { GlobalNavigationComponent } from './global-navigation/global-navigation.component';
import { GlobalNavigationSpanishComponent } from './global-navigation/global-navigation-spanish/global-navigation-spanish.component';
import { GlobalNavigationHindiComponent } from './global-navigation//global-navigation-hindi/global-navigation-hindi.component';
import { MenuDisplayComponent } from './menu-display/menu-display.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ToastComponent } from './toast/toast.component';
import { HeaderMultiLanguageComponent } from './header-multi-language/header-multi-language.component';
import { FooterMultiLanguageComponent } from './footer-multi-language/footer-multi-language.component';
import { FormElementComponent } from './form-element/form-element.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
import { ToggleComponent } from './toggle/toggle.component';
import { TabComponent } from './tab/tab.component';
import { NotificationInlineComponent } from './notification-inline/notification-inline.component';
import { HotCornerComponent } from './hot-corner/hot-corner.component';
import { FloatingPanelComponent } from './floating-panel/floating-panel.component'
import { ListComponent } from './list/list.component';
import { PagelistComponent } from './page-list/page-list.component';
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalnavdemoComponent } from './globalnavdemo/globalnavdemo.component';
import { DialogComponent } from './dialog/dialog.component';
import { SidePanelComponent } from './side-panel/side-panel.component';
import { SearchComponent } from './search/search.component';
import { CourseLevelContentCardComponent } from './course-level-content-card/course-level-content-card.component';
import { NavigationDrawerComponent } from './navigation-drawer/navigation-drawer.component';
import { NavigationDrawerCase1Component } from './navigation-drawer-case1/navigation-drawer-case1.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MenubarComponent } from './menubar/menubar.component';
import { CascadeMenubarComponent } from './cascade-menubar/cascade-menubar.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { ErrorStateComponent } from './error-state/error-state.component';
import { LinkComponent } from './link/link.component';
import { TextAreaComponent } from './text-area/text-area.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ReadAloudComponent } from './read-aloud/read-aloud.component';
import { DraggableComponent } from './draggable/draggable.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { PlayerComponent } from './player/player.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { TimeInputComponent } from './time-input/time-input.component';
import { LoaderComponent } from './loader/loader.component';
import { AccordianComponent } from './accordian/accordian.component';
import { ChipComponent } from './chip/chip.component';
import { BadgeComponent } from './badge/badge.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DateInputComponent } from './date-input/date-input.component';
import { PaginationComponent } from './pagination/pagination.component';
import { RadioComponent } from './radio/radio.component';
import { ListCardComponent } from './list-card/list-card.component';
import { IndicatorComponent } from './indicator/indicator.component';
import { TreeComponent } from './tree/tree.component';
import { FunctionCardComponent } from './function-card/function-card.component';
import { ActionCardComponent } from './action-card/action-card.component';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { MultiLevelProgressBarComponent } from './multi-level-progress-bar/multi-level-progress-bar.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TableComponent } from './table/table.component';
import { SampleModuleForNavigationDrawerComponent } from './sample-module-for-navigation-drawer/sample-module-for-navigation-drawer.component';
import { GlobalNavigationHeaderComponent } from './global-navigation-header/global-navigation.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { GradingCardComponent } from './grading-card/grading-card.component';
import { FilterToolbarComponent } from './filter-toolbar/filter-toolbar.component';
import { SummaryBarComponent } from './summary-bar/summary-bar.component';
import { ProgressCardComponent } from './progress-card/progress-card.component';
import { DialogFocusDirective } from './dialog/dailog.directive';
import { IconComponent } from './icon/icon.component';
import { ZoomComponent } from './zoom/zoom/zoom.component';
import { CommonModule } from '@angular/common';
import { CardSliderComponent } from './card-slider/card-slider.component';
import { MultiRangeSliderComponent } from './multi-range-slider/multi-range-slider.component';

import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';

import { register } from 'swiper/element/bundle';
import { carouselWithSlidebarComponent } from './carousel-with-slidebar/carousel-with-slidebar.component';
import { NavigationDrawerWithSubChildComponent } from './navigation-drawer-with-sub-child/navigation-drawer-with-sub-child.component';
register();

registerLocaleData(localeEn);
registerLocaleData(localeEs);
@NgModule({
  declarations: [
    AppComponent,
    ButtonComponent,
    CardComponent,
    FooterComponent,
    FooterMultiLanguageComponent,
    DropdownWithoutLabelComponent,
    TextEditorComponent,
    HeaderComponent,
    HeaderMultiLanguageComponent,
    ToastComponent,
    ModalHeaderComponent,
    GlobalNavigationComponent,
    GlobalNavigationSpanishComponent,
    GlobalNavigationHindiComponent,
    MenuDisplayComponent,
    NavbarComponent,
    StepperComponent,
    StepperwithrouteComponent,
    SidePanelComponent,
    SteponeComponent,
    SteptwoComponent,
    StepfinalComponent,
    ModalFooterComponent,
    ToggleComponent,
    FormElementComponent,
    SearchComponent,
    TabComponent,
    NotificationInlineComponent,
    HotCornerComponent,
    FloatingPanelComponent,
    ListComponent,
    PagelistComponent,
    GlobalHeaderComponent,
    GlobalnavdemoComponent,
    DialogComponent,
    CourseLevelContentCardComponent,
    ToolbarComponent,
    MenubarComponent,
    CascadeMenubarComponent,
    NavigationDrawerComponent,
    NavigationDrawerCase1Component,
    SampleModuleForNavigationDrawerComponent,
    DropdownComponent,
    ErrorStateComponent,
    BreadcrumbsComponent,
    LinkComponent,
    TextAreaComponent,
    BreadcrumbsComponent,
    ReadAloudComponent,
    DraggableComponent,
    ProgressBarComponent,
    CheckboxComponent,
    PlayerComponent,
    TooltipComponent,
    TimeInputComponent,
    LoaderComponent,
    AccordianComponent,
    BadgeComponent,
    SpinnerComponent,
    DateInputComponent,
    ChipComponent,
    PaginationComponent,
    RadioComponent,
    ListCardComponent,
    MultiSelectComponent,
    IndicatorComponent,
    TreeComponent,
    FunctionCardComponent,
    ActionCardComponent,
    NumericInputComponent,
    MultiLevelProgressBarComponent,
    TableComponent,
    GlobalNavigationHeaderComponent,
    PageHeaderComponent,
    GradingCardComponent,
    FilterToolbarComponent,
    SummaryBarComponent,
    ProgressCardComponent,
    DialogFocusDirective,
    IconComponent,
    ZoomComponent,
    CardSliderComponent,
    MultiRangeSliderComponent,
    carouselWithSlidebarComponent,
    NavigationDrawerWithSubChildComponent
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    MacedFrontendAngularComponentModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule 
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers:[provideClientHydration()],
  bootstrap: [AppComponent]
})
export class AppModule { }